/* eslint-disable */
import { PackagePointsComparison } from './ProductAndPricingTypes';

export const ugPackages = [
  {
    packageName: 'Visa',
    packagePrice: '9999',
    packageDescription: 'Get all ready for the last step with AdmitKard!',
    packageDetails: [
      {
        title: 'Visa Assistance',
        description: 'We assist you in finalizing the university, arranging VISA documents and proceed to file a VISA'
      },
      {
        title: 'Visa Filing',
        description: 'Not only we prepare the documents but put your file through the embassy with experts'
      },
      {
        title: 'Visa SOP/Interview',
        description: 'We train you for your VISA Interiew and prepare a VISA Sop that goes along with you VISA file'
      }
    ]
  },
  {
    packageName: 'Editing',
    packagePrice: '39999',
    packageDescription: 'Expert editing services to deliver the best',
    packageDetails: [
      {
        title: '5 Universites Applicable',
        description: 'We write a customized SOP/Essay per University'
      },
      {
        title: 'Essay/SOP Brainstorming',
        description: 'We interact with you to understand your aspirations, empathize with your cause and brainstorm on content.'
      },
      {
        title: 'Essay/SOP Editing',
        description: 'We analyse, critique, edit and structure drafts that get you an Admit!'
      },
      {
        title: 'Visa Assistance',
        description: 'Not only we prepare the documents but put your file through the embassy with expert inteview training and VISA SOP'
      }
    ]
  },
]

export const pgPackages = [
  {
    packageName: 'Visa',
    packagePrice: '11800',
    packageDescription: 'Get ready for the last step with AdmitKard!',
    packageDetails: [
      {
        title: 'Visa Assistance',
        description: 'We assist you in finalizing the university, arranging VISA documents and proceed to file a VISA'
      },
      {
        title: 'Visa Filing',
        description: 'Not only we prepare the documents but put your file through the embassy with experts'
      },
      {
        title: 'Visa SOP/Interview',
        description: 'We train you for your VISA Interiew and prepare a VISA Sop that goes along with you VISA file'
      }
    ]
  },
]

export const ugTestPreparations= [
  {
    packageName: 'SAT',
    packagePrice: '47900',
    packageDescription: 'SAT is required by students aiming UG admissions to measure verbal and mathematical skills of the candidates.',
    packageDetails: [
      {
        title: 'Course',
        description: '40 hours of instructions from SAT Certified Trainers with guided practice'
      },
      {
        title: 'Study Material',
        description: 'A fully developed course material to cover A-Z of SAT with Manual, Tests, Practice Booklets'
      },
      {
        title: 'Student Portal',
        description: 'Portal to track growth with online Proctoring tool, 31 Full length practice tests, Interactive score reports, 140+ hours of videos and much more via advanced learning portal'
      },
      {
        title: 'Mock Tests',
        description: '24 full length mock tests to make you test ready'
      },
      {
        title: 'Refresher Classes',
        description: '5 hours of Refresher sessions'
      },
      {
        title: 'Doubt Clearing Sessions',
        description: 'Unlimited doubt clearning sessions and 12 hours of test proctoring during the course'
      },
      {
        title: 'Study Plan',
        description: '12 months of SAT course validity with a 6-month access to the Student Portal'
      }
    ]
  },
  {
    packageName: 'ACT',
    packagePrice: '70396',
    packageDescription: 'A test that assesses your college readiness via math, english, science and writing',
    packageDetails: [
      {
        title: 'Course',
        description: '20 hours of instructions from ACT Certified Trainers with guided practice'
      },
      {
        title: 'Study Material',
        description: 'A fully developed course material to cover A-Z of ACT with Manual, Tests, Practice Booklets'
      },
      {
        title: 'Student Portal',
        description: 'Portal to track growth with online Proctoring too with practice tests, interactive score reports, videos and much more via advanced learning portal'
      },
      {
        title: 'Mock Tests',
        description: '14 full length mock tests to make you test ready'
      },
      {
        title: 'Refresher Classes',
        description: 'Referesh classes to boost your test prep'
      },
      {
        title: 'Study Plan',
        description: '12 months of course validity with a 6-month access to the Student Portal'
      }
    ]
  },
  {
    packageName: 'IELTS/TOEFL',
    packagePrice: '11000',
    packageDescription: 'An English Proficiency is needed to get you through university requiremenst',
    packageDetails: [
      {
        title: 'Course',
        description: '40 hours of instructions from IELTS Certified Trainers with guided practice'
      },
      {
        title: 'Study Material',
        description: 'A fully developed course material to cover A-Z of IELTS with Manual, Tests, Practice Booklets'
      },
      {
        title: 'Mock Tests',
        description: 'Mocks to make you test ready'
      },
      {
        title: 'Doubt Clearing Sessions',
        description: 'Unlimited Doubt Clearning Sessions'
      }
    ]
  }
]

export const pgTestPreparations= [
  {
    packageName: 'GRE',
    packagePrice: '20596',
    packageDescription: 'GRE is required by students aiming PG admissios to measure verbal and mathematical skills of the candidates',
    packageDetails: [
      {
        title: 'Course',
        description: '51 hours of instructions from Certified Trainers with guided practice'
      },
      {
        title: 'Study Material',
        description: 'A fully developed course material to cover A-Z of GRE with Manual, Tests, Practice Booklets'
      },
      {
        title: 'Student Portal',
        description: 'Portal to track growth with online Proctoring tool with practice tests, interactive score reports, 140+ hours of videos and much more via advanced learning portal'
      },
      {
        title: 'Recorded Videos',
        description: '140+ Recorded Videos to get you ready'
      },
      {
        title: 'Sectional Tests',
        description: '450+ Sectional Tests to help you master'
      },
      {
        title: 'Practise Questions',
        description: 'Practice bank of 3000+ questions'
      },
      {
        title: 'Full Length Adaptive Tests',
        description: '10 full length mock tests to make you test ready'
      },
      {
        title: 'AWA Reviews of GRE',
        description: 'Reviews of attempetd AWA by experts'
      },
      {
        title: 'Doubt Clearing Sessions',
        description: 'Unlimited Doubt Clearning Sessions'
      },
      {
        title: 'Study Plan',
        description: 'A fully customised study plan made just for you'
      }
    ]
  },
  {
    packageName: 'GMAT',
    packagePrice: '30519',
    packageDescription: 'GMAT is required by students aiming MBA admissios abroad',
    packageDetails: [
      {
        title: 'Course',
        description: '63 hours of instructions from ACT Certified Trainers with guided practice'
      },
      {
        title: 'Study Material',
        description: 'A fully developed course material to cover A-Z of GMAT with Manual, Tests, Practice Booklets'
      },
      {
        title: 'Student Portal',
        description: 'Portal to track growth with online Proctoring tool with practice tests, interactive score reports, 100+ hours of videos and much more via advanced learning portal'
      },
      {
        title: 'Recorded Videos',
        description: '100+ Recorded Videos to get you ready'
      },
      {
        title: 'Sectional Tests',
        description: '450+ Sectional Tests to help you master'
      },
      {
        title: 'Practise Questions',
        description: 'Practice bank of 3000+ questions'
      },
      {
        title: 'Full Length Adaptive Tests',
        description: '10 full length mock tests to make you test ready'
      },
      {
        title: 'Essay Grading of GMAT',
        description: 'Reviews of attempetd essays by experts'
      },
      {
        title: 'Doubt Clearing Sessions',
        description: 'Unlimited Doubt Clearning Sessions'
      },
      {
        title: 'Study Plan',
        description: 'A fully customised study plan made just for you'
      }
    ]
  },
  {
    packageName: 'IELTS/TOEFL',
    packagePrice: '11000',
    packageDescription: 'An English Proficiency is needed to get you through university requiremenst',
    packageDetails: [
      {
        title: 'Course',
        description: '40 hours of instructions from IELTS Certified Trainers with guided practice'
      },
      {
        title: 'Study Material',
        description: 'A fully developed course material to cover A-Z of IELTS with Manual, Tests, Practice Booklets'
      },
      {
        title: 'Mock Tests',
        description: 'Mocks to make you test ready'
      },
      {
        title: 'Doubt Clearing Sessions',
        description: 'Unlimited Doubt Clearning Sessions'
      }
    ]
  }
]

export const ugPackageComparisonTable: PackagePointsComparison[] = [
  {
    pointName: 'Counselling',
    pointComparisonColumns: ['Visa Only', 'Editing'],
    pointComparisonRows: [
      {
        rowHeading: 'Universities Shortlisting',
        rowDescription: 'We shortlist universities according to your profile in Dream, reach and Safe category from which you can finalize one perfect University after multiple rounds of brainstorming.',
        comparisonValues: ['no', 'yes', 'yes']
      },
      {
        rowHeading: 'Profile Evaluation',
        rowDescription: 'We aim to gain a clear understanding of your profile in terms of your education performance, career interest and aspirations. Decide & validate University Shortlisting related parameters i.e. Country finalization, course finalization, location preference, financial budget, plans post course completion, etc. Answer your immediate queries related to University Shortlisting parameters.',
        comparisonValues: ['no', 'no', 'yes']
      },
      {
        rowHeading: 'Profile Building',
        rowDescription: 'We make sure you geet closer to your dream University! We help you upskill in the right manner to cover the bridge between you nad your dream destination.',
        comparisonValues: ['no', 'no', 'yes']
      },
      {
        rowHeading: 'Admission Counselling',
        rowDescription: 'We want you to know what your real passion is and then select a suitable course that you are willing to pursue as your career. You personal coach spends time with you to understamd every little details and helps you figure out the perfect course basis your credentials, aspirations and will.',
        comparisonValues: ['no', 'no', 'yes']
      }
    ]
  },
  {
    pointName: 'Mentorship',
    pointComparisonColumns: ['Visa Only', 'Editing'],
    pointComparisonRows: [
      {
        rowHeading: 'Info Collect',
        rowDescription: 'What makes AdmitKard different is the truness of information. You will be assisted by a mentor at all steps, who is someone studyying already in your dream school! Be prepared even before you land in your study abroad country.',
        comparisonValues: ['no', 'no', 'yes']
      },
      {
        rowHeading: 'Guidance',
        rowDescription: 'The mentors guide you at each step until you secure a place abroad!',
        comparisonValues: ['no', 'no', 'yes']
      },
      {
        rowHeading: 'Resident Mentorship',
        rowDescription: 'Once you confirm your university, a mentor from the university that youre going to, will help you with pre-departure, post arrival, cheapest accommodations and part time jobs',
        comparisonValues: ['no', 'no', 'yes']
      }
    ]
  },
  {
    pointName: 'Editing',
    pointComparisonColumns: ['Visa Only', 'Editing'],
    pointComparisonRows: [
      {
        rowHeading: 'Essay/SOP Brainstorming',
        rowDescription: 'An Editor will be assigned to you once you finalize the universities to assist you in all your editorial work: like SOP, LORs, and Resume. The first draft comes from you and then the editor would closely interact with you to understand your aspirations, empathize with your cause and brainstorm on content.',
        comparisonValues: ['no', 'yes', 'yes']
      },
      {
        rowHeading: 'Essay/SOP Editing',
        rowDescription: 'Once analysed and decided, they would critique, edit, and structure your drafts within the required word limit.',
        comparisonValues: ['no', 'yes', 'yes']
      }
    ]
  },
  {
    pointName: 'Admissions',
    pointComparisonColumns: ['Visa Only', 'Editing'],
    pointComparisonRows: [
      {
        rowHeading: 'Application Submission',
        rowDescription: 'We help you in filling up your application form by providing you the application requirements and reviewing the final application for accuracy and completeness.',
        comparisonValues: ['no', 'no', 'yes']
      },
      {
        rowHeading: 'Interview Prep',
        rowDescription: 'We will assist in your interview preparations one you get the interview call. For this, we will conduct mock interview sessions and give you feedback to make improvements.',
        comparisonValues: ['no', 'no', 'yes']
      },
      {
        rowHeading: 'University Finalization',
        rowDescription: 'Once you receive admits from multiple universities, we togetherm will select the best suited school for you!',
        comparisonValues: ['no', 'no', 'yes']
      }
    ]
  },
  {
    pointName: 'Visa',
    pointComparisonColumns: ['Visa Only', 'Editing'],
    pointComparisonRows: [
      {
        rowHeading: 'Visa Assistance',
        rowDescription: 'The last stage is of VISA Counselling. When you receive admission offers we assist you in finalizing the university but the last choice will be yours.',
        comparisonValues: ['yes', 'yes', 'yes']
      },
      {
        rowHeading: 'Visa filing',
        rowDescription: 'Then we help you in your VISA application by assisting you in filing the Visa application, preparing the documents and conducting visa mock interview sessions.',
        comparisonValues: ['yes', 'yes', 'yes']
      }
    ]
  }
]

export const faqLists = [
  {
    title: 'For how long this package will be valid for?',
    description: 'Services are valid for 2 years from the intake you are targeting. You can come at any points of the timeline. We will build a customized package that suits you the best.' 
  },
  {
    title: 'Is my admission in premium university, guaranteed?',
    description: 'Our experts will help you to work on your application to get admission in your dream university at the best of the potential. The profile evalation is AI based to give you best suited Universlist list.' 
  },
  {
    title: 'How AdmitKard will help in profile strengthing activities',
    description: "We aim to gain a clear understanding of your profile in terms of your education performance, career interest and aspirations. Decide & validate University Shortlisting related parameters i.e. Country finalization, course finalization, location preference, financial budget, plans post course completion, etc. Answer your immediate queries related to University Shortlisting parameters. AK expert's will help you find out the gaps in your profile. And help you to finalise which activities to choose to make your profile more competitive."
  },
  {
    title: 'Can I meet my expert face to face?',
    description: "Yes, and coffee is on us! Meet us at your Noida office." 
  },
  {
    title: 'Is this process is going to be online?',
    description: 'Yes, this is completely digital process, you can take our services from any part of the world. AdmitKard wants to revolutionize the study abroad industry into a hassle free service of utmost quality and can be accessed by anyone, anywhere.' 
  },
  {
    title: 'In this package application fee / visa fee / courier charges are included?',
    description: 'No, we are service provider, we will help you getting all the service delivered to get admission in your dream university. All the other expenses i.e. application fee / visa fee / courier charges / any other charges has to incurred by student or parents' 
  },
  {
    title: 'What is validity of SAT / GRE / GMAT / ACT testprep',
    description: 'Validity of testprep is 1 year from the date of enrollment into a specific program.' 
  },
  {
    title: 'Can I get refund?',
    description: 'No, it would not be possible for us to generate refunds. But, be rest assured about the quality of services. Our aim is to make you succeed, and in that, you would never have to ask for refunds.' 
  },
  {
    title: 'What all services will you provide?',
    description: 'If you are looking to be a UG student, visit the UG Consilium page and if you are aiming Masters, view our PG packages.' 
  },
  {
    title: 'Do you provide test prep?',
    description: 'AdmitKard is a one stop shop. We bring to you all services at a single place. Consult an AK Expert to understand the tests and packages that you can aim.' 
  }
]
